import { StateReducers }  from 'state/reducers/types/StateReducers'

interface Props {
  state: StateReducers
}

export const getIsAndroidNative = ({ state }: Props): boolean => {
  return state.cookieStorage?.platform === 'AndroidNative'
}
